// import {
//   ListViewProvider,
//   useListView,
// } from '../../../data-administration/data-admininstration-list/core/ListViewProvider'
// import { QueryRequestProvider } from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'
// import { QueryResponseProvider } from '../../../data-administration/data-admininstration-list/core/QueryResponseProvider'
// import { UsersListHeader } from '../../../data-administration/data-admininstration-list/components/header/UsersListHeader'
// import { UsersTable } from '../../../data-administration/data-admininstration-list/table/UsersTable'
// import { UserEditModal } from '../../../data-administration/data-admininstration-list/form-edit-modal/CoomonEditModal'
// import { KTCard } from '../../../../../../_metronic/helpers'
// import { Card4 } from '../../../../../../_metronic/partials/content/cards/Card4'
// import { roleColumns } from './_columns'
// import { useState } from 'react'
// import { useEffect } from 'react'
// import { successToast } from '../../../../../../_metronic/helpers/components/Toaster'

// const mockedData = [
//   { id: '1', currencyName: 'US Dollar', shortForm: 'USD', symbol: '$' },
//   { id: '2', currencyName: 'Philippine Peso', shortForm: 'PHP', symbol: 'P' },
// ]

// interface PersonalDetails {
//   name?: string;
//   // Add other properties as needed
// }

// interface SupplyChainOption {
//   id: string;
//   name?: string;
//   firstName?: string;
//   userName?: string;
//   personalDetails?: PersonalDetails;
//   // Add other properties as needed based on your API response
// }




// interface FormData {
//   supplyChain: string;
//   imageCount: string;
//   freeTextRemarks: string;
//   pointOfOrigin: string;
//   editMaterial: string;
//   supplierRating: string;
//   batchManagement: string;
//   pricingInfo: string;
//   paymentRecord: string;
// }

// const UsersList = () => {
//   const [supplyChainOptions, setSupplyChainOptions] = useState<SupplyChainOption[]>([]);
//   const [loading, setLoading] = useState(false);

//   const [showQRModal, setShowQRModal] = useState(false);


//   const [originalFormData, setOriginalFormData] = useState<FormData | null>(null);
//   const [formData, setFormData] = useState<FormData>({
//     supplyChain: '',
//     imageCount: '',
//     freeTextRemarks: 'no',
//     pointOfOrigin: 'no',
//     editMaterial: 'no',
//     supplierRating: 'no',
//     batchManagement: 'Manual',
//     pricingInfo: 'no',
//     paymentRecord: 'no'
//   });
//   const [hasChanges, setHasChanges] = useState(false);

//   const getAuthToken = () => {
//     try {
//       const authData = localStorage.getItem('kt-auth-react-v');
//       if (authData) {
//         const parsedData = JSON.parse(authData);
//         return parsedData.data?.token || null;
//       }
//       return null;
//     } catch (error) {
//       console.error('Error parsing auth data from localStorage:', error);
//       return null;
//     }
//   };

//   const fetchSupplyChainOptions = async () => {
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         console.error('No auth token found');
//         return;
//       }

//       const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}users?page=0&size=10&type=FRANCHISE`, {
//         headers: {
//           'Authorization': token,
//           'Accept': 'application/json',
//           'Content-Type': 'application/json'
//         }
//       });

//       if (!response.ok) {
//         throw new Error('Failed to fetch supply chain options');
//       }
//       const data = await response.json();
//       setSupplyChainOptions(data.content || data);
//     } catch (error) {
//       console.error('Error fetching supply chain options:', error);
//       setSupplyChainOptions([]);
//     }
//   };

//   useEffect(() => {
//     fetchSupplyChainOptions();
//   }, []);
//   const handleRadioChange = (field, value) => {
//     setFormData(prev => {
//       const newData = { ...prev, [field]: value };
//       const hasSupplyChain = newData.supplyChain !== '';
//       const hasActualChanges = JSON.stringify(newData) !== JSON.stringify(originalFormData);
//       setHasChanges(hasSupplyChain && hasActualChanges);
//       return newData;
//     });
//   };


//   const handleInputChange = (field, value) => {
//     setFormData(prev => {
//       const newData = { ...prev, [field]: value };
//       const hasSupplyChain = newData.supplyChain !== '';
//       const hasActualChanges = JSON.stringify(newData) !== JSON.stringify(originalFormData);
//       setHasChanges(hasSupplyChain && hasActualChanges);
//       return newData;
//     });
//   };

//   const handleSave = async () => {
//     // Add validation
//     if (!formData.supplyChain) {
//       alert('Please select a supply chain');
//       return;
//     }
//     if (!formData.imageCount) {
//       alert('Please enter the number of images');
//       return;
//     }

//     setLoading(true);
//     const token = getAuthToken();
//     if (!token) {
//       console.error('No auth token found');
//       setLoading(false);
//       return;
//     }

//     // const payload = {
//     //   mandatoryImages: formData.imageCount,
//     //   addRemarks: formData.freeTextRemarks === 'yes',
//     //   supplierRating: formData.supplierRating === 'yes',
//     //   pointOfOrgin: formData.pointOfOrigin === 'yes',
//     //   twoFactor: formData.editMaterial === 'yes'
//     // };




//     // const payload = {
//     //   "preferences": {
//     //     mandatoryImages: formData.imageCount,
//     //     addRemarks: formData.freeTextRemarks === 'yes',
//     //     supplierRating: formData.supplierRating === 'yes',
//     //     pointOfOrgin: formData.pointOfOrigin === 'yes',
//     //     twoFactor: formData.editMaterial === 'yes'
//     //   }
//     // }




//     // const payload = {
//     //   "preferences": {
//     //     mandatoryImages: formData.imageCount,
//     //     addRemarks: formData.freeTextRemarks === 'yes',
//     //     supplierRating: formData.supplierRating === 'yes',
//     //     pointOfOrgin: formData.pointOfOrigin === 'yes',
//     //     twoFactor: formData.editMaterial === 'yes',
//     //     batchManagement: formData.batchManagement === 'Manual' ? 'MANUAL' : 'AUTO',
//     //     // paymentRecord: formData.paymentRecord === 'yes'
//     //     pricingInfo: formData.paymentRecord === 'yes'
//     //   }
//     // }
//     const payload = {
//       "preferences": {
//         mandatoryImages: formData.imageCount,
//         addRemarks: formData.freeTextRemarks === 'yes',
//         supplierRating: formData.supplierRating === 'yes',
//         pointOfOrgin: formData.pointOfOrigin === 'yes',
//         twoFactor: formData.editMaterial === 'yes',
//         batchManagement: formData.batchManagement === 'Manual' ? 'MANUAL' : 'AUTO',
//         pricingInfo: formData.pricingInfo === 'yes',
//         paymentRecord: formData.paymentRecord === 'yes'
//       }
//     }
//     try {
//       const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}customSettings/${formData.supplyChain}/update`, {
//         method: 'PUT',
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//           'Authorization': token
//         },
//         body: JSON.stringify(payload)
//       });

//       if (response.ok) {
//         console.log('Settings saved successfully');
//         successToast('Settings saved successfully!');
//       } else {
//         console.error('Failed to save settings');
//         alert('Failed to save settings');
//       }
//     } catch (error) {
//       console.error('Error saving settings:', error);
//       alert('Error saving settings');
//     } finally {
//       setLoading(false);
//     }
//   };




//   useEffect(() => {
//     if (formData.supplyChain) {
//       fetchUserSettings();
//     }
//   }, [formData.supplyChain]);


//   const fetchUserSettings = async () => {
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         console.error('No auth token found');
//         return;
//       }

//       const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}users/${formData.supplyChain}`, {
//         headers: {
//           'Authorization': token,
//           'Accept': 'application/json',
//           'Content-Type': 'application/json'
//         }
//       });

//       if (!response.ok) {
//         throw new Error('Failed to fetch user settings');
//       }
//       const data = await response.json();

//       const preferences = data.customSettings?.preferences || {};
//       // const mappedData = {
//       //   supplyChain: formData.supplyChain,
//       //   imageCount: preferences.mandatoryImages || '',
//       //   freeTextRemarks: preferences.addRemarks ? 'yes' : 'no',
//       //   pointOfOrigin: preferences.pointOfOrgin ? 'yes' : 'no',
//       //   editMaterial: preferences.twoFactor ? 'yes' : 'no',
//       //   supplierRating: preferences.supplierRating ? 'yes' : 'no',
//       //   batchManagement: preferences.batchManagement === 'AUTO' ? 'Automatic' : 'Manual',
//       //   paymentRecord: preferences.paymentRecord ? 'yes' : 'no'
//       // };
//       const mappedData = {
//         supplyChain: formData.supplyChain,
//         imageCount: preferences.mandatoryImages || '',
//         freeTextRemarks: preferences.addRemarks ? 'yes' : 'no',
//         pointOfOrigin: preferences.pointOfOrgin ? 'yes' : 'no',
//         editMaterial: preferences.twoFactor ? 'yes' : 'no',
//         supplierRating: preferences.supplierRating ? 'yes' : 'no',
//         batchManagement: preferences.batchManagement === 'AUTO' ? 'Automatic' : 'Manual',
//         pricingInfo: preferences.pricingInfo ? 'yes' : 'no',
//         paymentRecord: preferences.paymentRecord ? 'yes' : 'no'
//       };
//       setFormData(mappedData);
//       setOriginalFormData(mappedData);
//       setHasChanges(false);

//     } catch (error) {
//       console.error('Error fetching user settings:', error);
//     }
//   };



//   const handleBatchManagementChange = (value) => {
//     if (value === 'Manual') {
//       setShowQRModal(true);
//     } else {
//       handleRadioChange('batchManagement', value);
//     }
//   };


//   return (
//     <KTCard>
//       <div style={{
//         padding: '20px',
//         // maxWidth: '800px',
//         fontFamily: 'Arial, sans-serif',
//         maxWidth: '1000px', // Changed from 800px
//       }}>
//         <div style={{
//           padding: '20px'
//         }}>
//           {/* Supply chain Dropdown */}
//           <div style={{
//             padding: '15px',
//             marginBottom: '15px'
//           }}>
//             <div style={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: '20px'
//             }}>
//               <label style={{
//                 color: 'black',
//                 fontWeight: 'normal',
//                 fontSize: '16px'
//               }}>
//                 Select Supply chain
//               </label>
//               <select
//                 value={formData.supplyChain}
//                 onChange={(e) => handleInputChange('supplyChain', e.target.value)}
//                 style={{
//                   border: '1px solid black',
//                   borderRadius: '6px',
//                   padding: '8px 15px',
//                   color: 'black',
//                   backgroundColor: 'white',
//                   fontSize: '14px',
//                   fontWeight: 'normal'
//                 }}
//               >
//                 <option value="">Drop Down</option>
//                 {supplyChainOptions.map((option) => (
//                   <option key={option.id} value={option.id}>
//                     {option?.personalDetails?.name || option?.name || option?.firstName || option?.userName}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           {/* Image Count Input */}
//           <div style={{
//             padding: '15px',
//             marginBottom: '15px'
//           }}>
//             <div style={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center'
//             }}>
//               <label style={{
//                 color: 'black',
//                 fontWeight: 'normal',
//                 fontSize: '16px',
//                 flex: 1
//               }}>
//                 Enter the number of images which should be mandatorily collected for every transaction
//               </label>
//               <div style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '10px'
//               }}>
//                 <input
//                   type="number"
//                   value={formData.imageCount}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     // Only allow 0, 1, or 2
//                     if (value === '' || (parseInt(value) >= 0 && parseInt(value) <= 2)) {
//                       handleInputChange('imageCount', value);
//                     }
//                   }}
//                   onKeyPress={(e) => {
//                     // Prevent non-numeric characters and numbers > 2
//                     if (!/[0-2]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
//                       e.preventDefault();
//                     }
//                   }}
//                   style={{
//                     border: '1px solid black',
//                     borderRadius: '6px',
//                     padding: '8px 12px',
//                     color: 'black',
//                     backgroundColor: 'white',
//                     fontSize: '14px',
//                     fontWeight: 'normal',
//                     width: '80px'
//                   }}
//                   max="2"
//                   min="0"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Free Text Remarks */}
//           <div style={{
//             padding: '15px',
//             marginBottom: '15px'
//           }}>
//             <div style={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center'
//             }}>
//               <label style={{
//                 color: 'black',
//                 fontWeight: 'normal',
//                 fontSize: '16px',
//                 flex: 1
//               }}>
//                 Do you want to free text remarks for material collection and dispatch
//               </label>
//               <div style={{
//                 display: 'flex',
//                 gap: '20px'
//               }}>
//                 <label style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '5px',
//                   cursor: 'pointer'
//                 }}>
//                   <input
//                     type="radio"
//                     name="freeTextRemarks"
//                     value="yes"
//                     checked={formData.freeTextRemarks === 'yes'}
//                     onChange={(e) => handleRadioChange('freeTextRemarks', e.target.value)}
//                     style={{
//                       accentColor: 'black'
//                     }}
//                   />
//                   <span style={{
//                     color: 'black',
//                     fontWeight: 'normal',
//                     fontSize: '16px'
//                   }}>
//                     Yes
//                   </span>
//                 </label>
//                 <label style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '5px',
//                   cursor: 'pointer'
//                 }}>
//                   <input
//                     type="radio"
//                     name="freeTextRemarks"
//                     value="no"
//                     checked={formData.freeTextRemarks === 'no'}
//                     onChange={(e) => handleRadioChange('freeTextRemarks', e.target.value)}
//                     style={{
//                       accentColor: 'black'
//                     }}
//                   />
//                   <span style={{
//                     color: 'black',
//                     fontWeight: 'normal',
//                     fontSize: '16px'
//                   }}>
//                     No
//                   </span>
//                 </label>
//               </div>
//             </div>
//           </div>

//           {/* Point of Origin */}
//           <div style={{
//             padding: '15px',
//             marginBottom: '15px'
//           }}>
//             <div style={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center'
//             }}>
//               <label style={{
//                 color: 'black',
//                 fontWeight: 'normal',
//                 fontSize: '16px',
//                 flex: 1
//               }}>
//                 Do you need to capture the "Point of Origin" for the material collection
//               </label>
//               <div style={{
//                 display: 'flex',
//                 gap: '20px'
//               }}>
//                 <label style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '5px',
//                   cursor: 'pointer'
//                 }}>
//                   <input
//                     type="radio"
//                     name="pointOfOrigin"
//                     value="yes"
//                     checked={formData.pointOfOrigin === 'yes'}
//                     onChange={(e) => handleRadioChange('pointOfOrigin', e.target.value)}
//                     style={{
//                       accentColor: 'black'
//                     }}
//                   />
//                   <span style={{
//                     color: 'black',
//                     fontWeight: 'normal',
//                     fontSize: '16px'
//                   }}>
//                     Yes
//                   </span>
//                 </label>
//                 <label style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '5px',
//                   cursor: 'pointer'
//                 }}>
//                   <input
//                     type="radio"
//                     name="pointOfOrigin"
//                     value="no"
//                     checked={formData.pointOfOrigin === 'no'}
//                     onChange={(e) => handleRadioChange('pointOfOrigin', e.target.value)}
//                     style={{
//                       accentColor: 'black'
//                     }}
//                   />
//                   <span style={{
//                     color: 'black',
//                     fontWeight: 'normal',
//                     fontSize: '16px'
//                   }}>
//                     No
//                   </span>
//                 </label>
//               </div>
//             </div>
//           </div>

//           {/* Edit Material */}
//           <div style={{
//             padding: '15px',
//             marginBottom: '15px'
//           }}>
//             <div style={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center'
//             }}>
//               <label style={{
//                 color: 'black',
//                 fontWeight: 'normal',
//                 fontSize: '16px',
//                 flex: 1
//               }}>
//                 Do you need an option to edit the material inwarding after recorded from mobile app
//               </label>
//               <div style={{
//                 display: 'flex',
//                 gap: '20px'
//               }}>
//                 <label style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '5px',
//                   cursor: 'pointer'
//                 }}>
//                   <input
//                     type="radio"
//                     name="editMaterial"
//                     value="yes"
//                     checked={formData.editMaterial === 'yes'}
//                     onChange={(e) => handleRadioChange('editMaterial', e.target.value)}
//                     style={{
//                       accentColor: 'black'
//                     }}
//                   />
//                   <span style={{
//                     color: 'black',
//                     fontWeight: 'normal',
//                     fontSize: '16px'
//                   }}>
//                     Yes
//                   </span>
//                 </label>
//                 <label style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '5px',
//                   cursor: 'pointer'
//                 }}>
//                   <input
//                     type="radio"
//                     name="editMaterial"
//                     value="no"
//                     checked={formData.editMaterial === 'no'}
//                     onChange={(e) => handleRadioChange('editMaterial', e.target.value)}
//                     style={{
//                       accentColor: 'black'
//                     }}
//                   />
//                   <span style={{
//                     color: 'black',
//                     fontWeight: 'normal',
//                     fontSize: '16px'
//                   }}>
//                     No
//                   </span>
//                 </label>
//               </div>
//             </div>
//           </div>

//           {/* Supplier Rating */}
//           <div style={{
//             padding: '15px'
//           }}>
//             <div style={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center'
//             }}>
//               <label style={{
//                 color: 'black',
//                 fontWeight: 'normal',
//                 fontSize: '16px',
//                 flex: 1
//               }}>
//                 Do you need the supplier rating function
//               </label>
//               <div style={{
//                 display: 'flex',
//                 gap: '20px'
//               }}>
//                 <label style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '5px',
//                   cursor: 'pointer'
//                 }}>
//                   <input
//                     type="radio"
//                     name="supplierRating"
//                     value="yes"
//                     checked={formData.supplierRating === 'yes'}
//                     onChange={(e) => handleRadioChange('supplierRating', e.target.value)}
//                     style={{
//                       accentColor: 'black'
//                     }}
//                   />
//                   <span style={{
//                     color: 'black',
//                     fontWeight: 'normal',
//                     fontSize: '16px'
//                   }}>
//                     Yes
//                   </span>
//                 </label>
//                 <label style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '5px',
//                   cursor: 'pointer'
//                 }}>
//                   <input
//                     type="radio"
//                     name="supplierRating"
//                     value="no"
//                     checked={formData.supplierRating === 'no'}
//                     onChange={(e) => handleRadioChange('supplierRating', e.target.value)}
//                     style={{
//                       accentColor: 'black'
//                     }}
//                   />
//                   <span style={{
//                     color: 'black',
//                     fontWeight: 'normal',
//                     fontSize: '16px'
//                   }}>
//                     No
//                   </span>
//                 </label>
//               </div>
//             </div>
//           </div>




//           {/* Batch Management */}
//           <div style={{ padding: '15px', marginBottom: '15px' }}>
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//               <label style={{ color: 'black', fontWeight: 'normal', fontSize: '16px', flex: 1 }}>
//                 How do you want to do batch management in the supply chain
//               </label>
//               <div style={{ display: 'flex', gap: '20px' }}>
//                 <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }}>
//                   <input
//                     type="radio"
//                     name="batchManagement"
//                     value="Manual"
//                     checked={formData.batchManagement === 'Manual'}
//                     // onChange={(e) => handleRadioChange('batchManagement', e.target.value)}
//                     onChange={(e) => handleBatchManagementChange(e.target.value)}
//                     style={{ accentColor: 'black' }}
//                   />
//                   <span style={{ color: 'black', fontWeight: 'normal', fontSize: '16px' }}>Manual</span>
//                 </label>
//                 <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }}>
//                   <input
//                     type="radio"
//                     name="batchManagement"
//                     value="Automatic"
//                     checked={formData.batchManagement === 'Automatic'}
//                     onChange={(e) => handleRadioChange('batchManagement', e.target.value)}
//                     style={{ accentColor: 'black' }}
//                   />
//                   <span style={{ color: 'black', fontWeight: 'normal', fontSize: '16px' }}>Automatic</span>
//                 </label>
//               </div>
//             </div>
//           </div>

//           {/* Pricing Information */}
//           <div style={{ padding: '15px', marginBottom: '15px' }}>
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//               <label style={{ color: 'black', fontWeight: 'normal', fontSize: '16px', flex: 1 }}>
//                 Do you want to record the pricing information while buying and selling
//               </label>
//               <div style={{ display: 'flex', gap: '20px' }}>
//                 <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }}>
//                   <input
//                     type="radio"
//                     name="pricingInfo"
//                     value="yes"
//                     checked={formData.pricingInfo === 'yes'}
//                     onChange={(e) => handleRadioChange('pricingInfo', e.target.value)}
//                     style={{ accentColor: 'black' }}
//                   />
//                   <span style={{ color: 'black', fontWeight: 'normal', fontSize: '16px' }}>Yes</span>
//                 </label>
//                 <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }}>
//                   <input
//                     type="radio"
//                     name="pricingInfo"
//                     value="no"
//                     checked={formData.pricingInfo === 'no'}
//                     onChange={(e) => handleRadioChange('pricingInfo', e.target.value)}
//                     style={{ accentColor: 'black' }}
//                   />
//                   <span style={{ color: 'black', fontWeight: 'normal', fontSize: '16px' }}>No</span>
//                 </label>
//               </div>
//             </div>
//           </div>

//           {/* Payment Record */}
//           <div style={{ padding: '15px', marginBottom: '15px' }}>
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//               <label style={{ color: 'black', fontWeight: 'normal', fontSize: '16px', flex: 1 }}>
//                 Do you want to record mode of payment while buying the materials
//               </label>
//               <div style={{ display: 'flex', gap: '20px' }}>
//                 <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }}>
//                   <input
//                     type="radio"
//                     name="paymentRecord"
//                     value="yes"
//                     checked={formData.paymentRecord === 'yes'}
//                     onChange={(e) => handleRadioChange('paymentRecord', e.target.value)}
//                     style={{ accentColor: 'black' }}
//                   />
//                   <span style={{ color: 'black', fontWeight: 'normal', fontSize: '16px' }}>Yes</span>
//                 </label>
//                 <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }}>
//                   <input
//                     type="radio"
//                     name="paymentRecord"
//                     value="no"
//                     checked={formData.paymentRecord === 'no'}
//                     onChange={(e) => handleRadioChange('paymentRecord', e.target.value)}
//                     style={{ accentColor: 'black' }}
//                   />
//                   <span style={{ color: 'black', fontWeight: 'normal', fontSize: '16px' }}>No</span>
//                 </label>
//               </div>
//             </div>
//           </div>

//           {/* Save Button */}
//           <div style={{
//             padding: '20px',
//             textAlign: 'right',
//             borderTop: '1px solid #eee',
//             marginTop: '20px'
//           }}>
//             <button
//               onClick={handleSave}
//               disabled={loading || !hasChanges}
//               style={{
//                 backgroundColor: (loading || !hasChanges) ? '#ccc' : '#007bff',
//                 color: 'white',
//                 border: 'none',
//                 borderRadius: '6px',
//                 padding: '12px 30px',
//                 fontSize: '16px',
//                 fontWeight: 'normal',
//                 cursor: (loading || !hasChanges) ? 'not-allowed' : 'pointer'
//               }}
//             >
//               {loading ? 'Saving...' : 'Save'}
//             </button>
//           </div>
//         </div>

//         {/* QR Code Modal */}
//         {showQRModal && (
//           // <div style={{
//           //   position: 'fixed',
//           //   top: 0,
//           //   left: 0,
//           //   right: 0,
//           //   bottom: 0,
//           //   backgroundColor: 'rgba(0,0,0,0.5)',
//           //   display: 'flex',
//           //   justifyContent: 'center',
//           //   alignItems: 'center',
//           //   zIndex: 1000
//           // }}>
//           //   <div style={{
//           //     backgroundColor: 'white',
//           //     padding: '30px',
//           //     borderRadius: '8px',
//           //     maxWidth: '500px',
//           //     textAlign: 'center'
//           //   }}>
//           //     <h3>⚠ Enable QR Code based material tracking Mode?</h3>
//           //     <p>Are you equipped with QR code printers to print batch tags for each bag, bale, or jumbo bag?</p>
//           //     <p>Enabling this mode will require QR code scanning on every SKU to record all activities accurately.</p>
//           //     <p style={{ color: 'green' }}>✅ Are you sure you want to proceed?</p>
//           //     <p style={{ fontSize: '12px', color: '#666' }}>
//           //       If you're unsure or need assistance, please contact the Helpdesk before enabling this mode.
//           //     </p>
//           //     <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '20px' }}>
//           //       <button
//           //         onClick={() => {
//           //           handleRadioChange('batchManagement', 'Manual');
//           //           setShowQRModal(false);
//           //         }}
//           //         style={{ backgroundColor: '#007bff', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '4px' }}
//           //       >
//           //         Yes, Proceed
//           //       </button>
//           //       <button
//           //         onClick={() => setShowQRModal(false)}
//           //         style={{ backgroundColor: '#6c757d', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '4px' }}
//           //       >
//           //         Cancel
//           //       </button>
//           //     </div>
//           //   </div>
//           // </div>

//           <div style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundColor: 'rgba(0,0,0,0.1)',
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             zIndex: 1000
//           }}>
//             <div style={{
//               backgroundColor: '#fff5f8',
//               borderRadius: '12px',
//               maxWidth: '650px',
//               position: 'relative',
//               border: 'none'
//             }}>
//               <button
//                 type="button"
//                 className="position-absolute"
//                 style={{
//                   top: '15px',
//                   right: '15px',
//                   background: 'none',
//                   border: 'none',
//                   fontSize: '20px',
//                   color: 'black',
//                   cursor: 'pointer',
//                   padding: '0',
//                   width: '24px',
//                   height: '24px',
//                   zIndex: 1000,
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center'
//                 }}
//                 onClick={() => setShowQRModal(false)}
//               >
//                 ×
//               </button>

//               <div className="text-center py-5" style={{ padding: '40px' }}>
//                 <div className="mb-4 d-flex justify-content-center">
//                   <lottie-player
//                     src="/success-animation.json"
//                     background="transparent"
//                     speed="1"
//                     style={{ width: '80px', height: '80px' }}
//                     loop={false}
//                     autoplay
//                   />
//                 </div>

//                 <h4 style={{ color: '#1f2937', fontWeight: '600', marginBottom: '20px' }}>
//                   ⚠ Enable QR Code based material tracking Mode?
//                 </h4>

//                 <p style={{ color: '#6b7280', marginBottom: '30px', lineHeight: '1.5' }}>
//                   Are you equipped with QR code printers to print batch tags for each bag, bale, or jumbo bag?
//                 </p>
//                 <p style={{ color: '#6b7280', marginBottom: '30px', lineHeight: '1.5' }}>
//                   Enabling this mode will require QR code scanning on every SKU to record all activities accurately.
//                 </p>
//                 <p style={{ color: 'green', marginBottom: '30px', lineHeight: '1.5' }}>
//                   ✅ Are you sure you want to proceed?
//                 </p>
//                 <p style={{ fontSize: '12px', color: '#666', marginBottom: '30px', lineHeight: '1.5' }}>
//                   If you're unsure or need assistance, please contact the Helpdesk before enabling this mode.
//                 </p>

//                 <div className="d-flex justify-content-center">
//                   <button
//                     type="button"
//                     className="btn"
//                     style={{
//                       backgroundColor: 'transparent',
//                       border: '1px solid #f1416c',
//                       color: '#f1416c',
//                       padding: '10px 24px',
//                       borderRadius: '8px',
//                       fontWeight: '500',
//                       marginRight: "10px"
//                     }}
//                     onClick={() => setShowQRModal(false)}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="button"
//                     className="btn"
//                     style={{
//                       backgroundColor: '#f1416c',
//                       border: 'none',
//                       color: 'white',
//                       padding: '10px 24px',
//                       borderRadius: '8px',
//                       fontWeight: '500'
//                     }}
//                     onClick={() => {
//                       handleRadioChange('batchManagement', 'Manual');
//                       setShowQRModal(false);
//                     }}
//                   >
//                     Yes, Proceed
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>


//     </KTCard>
//   )
// }

// const AppSetting = () => (
//   <QueryRequestProvider initialValue={{ initialApi: 'auditStandards' }}>
//     <QueryResponseProvider>
//       <ListViewProvider>
//         <UsersList />
//       </ListViewProvider>
//     </QueryResponseProvider>
//   </QueryRequestProvider>
// )

// export { AppSetting }




import {
  ListViewProvider,
  useListView,
} from '../../../data-administration/data-admininstration-list/core/ListViewProvider'
import { QueryRequestProvider } from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'
import { QueryResponseProvider } from '../../../data-administration/data-admininstration-list/core/QueryResponseProvider'
import { UsersListHeader } from '../../../data-administration/data-admininstration-list/components/header/UsersListHeader'
import { UsersTable } from '../../../data-administration/data-admininstration-list/table/UsersTable'
import { UserEditModal } from '../../../data-administration/data-admininstration-list/form-edit-modal/CoomonEditModal'
import { KTCard } from '../../../../../../_metronic/helpers'
import { Card4 } from '../../../../../../_metronic/partials/content/cards/Card4'
import { roleColumns } from './_columns'
import { useState } from 'react'
import { useEffect } from 'react'
import React from 'react'
import { successToast } from '../../../../../../_metronic/helpers/components/Toaster'

const mockedData = [
  { id: '1', currencyName: 'US Dollar', shortForm: 'USD', symbol: '$' },
  { id: '2', currencyName: 'Philippine Peso', shortForm: 'PHP', symbol: 'P' },
]

interface PersonalDetails {
  name?: string;
}

interface SupplyChainOption {
  id: string;
  name?: string;
  firstName?: string;
  userName?: string;
  personalDetails?: PersonalDetails;
}

interface FormData {
  supplyChain: string;
  imageCount: string;
  freeTextRemarks: string;
  pointOfOrigin: string;
  editMaterial: string;
  supplierRating: string;
  batchManagement: string;
  pricingInfo: string;
  paymentRecord: string;
}

const checkboxStyle: React.CSSProperties = {
  appearance: 'none',
  width: '24px',
  height: '24px',
  // border: '2px solid #007AFF',
  borderRadius: '6px',
  backgroundColor: 'lightgray',
  cursor: 'pointer',
  position: 'relative',
  transition: 'all 0.2s ease',
  WebkitAppearance: 'none',
  MozAppearance: 'none'
};

const checkboxCheckedStyle: React.CSSProperties = {
  ...checkboxStyle,
  backgroundColor: '#007AFF',
  borderColor: '#007AFF'
};

const UsersList = () => {
  const [supplyChainOptions, setSupplyChainOptions] = useState<SupplyChainOption[]>([]);
  const [loading, setLoading] = useState(false);
  const [showQRModal, setShowQRModal] = useState(false);
  const [originalFormData, setOriginalFormData] = useState<FormData | null>(null);
  const [formData, setFormData] = useState<FormData>({
    supplyChain: '',
    imageCount: '',
    freeTextRemarks: 'no',
    pointOfOrigin: 'no',
    editMaterial: 'no',
    supplierRating: 'no',
    batchManagement: 'Manual',
    pricingInfo: 'no',
    paymentRecord: 'no'
  });
  const [hasChanges, setHasChanges] = useState(false);

  const getAuthToken = () => {
    try {
      const authData = localStorage.getItem('kt-auth-react-v');
      if (authData) {
        const parsedData = JSON.parse(authData);
        return parsedData.data?.token || null;
      }
      return null;
    } catch (error) {
      console.error('Error parsing auth data from localStorage:', error);
      return null;
    }
  };

  const fetchSupplyChainOptions = async () => {
    try {
      const token = getAuthToken();
      if (!token) {
        console.error('No auth token found');
        return;
      }

      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}users?page=0&size=10&type=FRANCHISE`, {
        headers: {
          'Authorization': token,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch supply chain options');
      }
      const data = await response.json();
      setSupplyChainOptions(data.content || data);
    } catch (error) {
      console.error('Error fetching supply chain options:', error);
      setSupplyChainOptions([]);
    }
  };

  useEffect(() => {
    fetchSupplyChainOptions();
  }, []);

  const handleRadioChange = (field, value) => {
    setFormData(prev => {
      const newData = { ...prev, [field]: value };
      const hasSupplyChain = newData.supplyChain !== '';
      const hasActualChanges = JSON.stringify(newData) !== JSON.stringify(originalFormData);
      setHasChanges(hasSupplyChain && hasActualChanges);
      return newData;
    });
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => {
      const newData = { ...prev, [field]: value };
      const hasSupplyChain = newData.supplyChain !== '';
      const hasActualChanges = JSON.stringify(newData) !== JSON.stringify(originalFormData);
      setHasChanges(hasSupplyChain && hasActualChanges);
      return newData;
    });
  };

  const handleSave = async () => {
    if (!formData.supplyChain) {
      alert('Please select a supply chain');
      return;
    }
    if (!formData.imageCount) {
      alert('Please enter the number of images');
      return;
    }

    setLoading(true);
    const token = getAuthToken();
    if (!token) {
      console.error('No auth token found');
      setLoading(false);
      return;
    }

    const payload = {
      "preferences": {
        mandatoryImages: formData.imageCount,
        addRemarks: formData.freeTextRemarks === 'yes',
        supplierRating: formData.supplierRating === 'yes',
        pointOfOrgin: formData.pointOfOrigin === 'yes',
        twoFactor: formData.editMaterial === 'yes',
        batchManagement: formData.batchManagement === 'Manual' ? 'MANUAL' : 'AUTO',
        pricingInfo: formData.pricingInfo === 'yes',
        paymentRecord: formData.paymentRecord === 'yes'
      }
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}customSettings/${formData.supplyChain}/update`, {
        method: 'PUT',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': token
        },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        console.log('Settings saved successfully');
        successToast('Settings saved successfully!');
      } else {
        console.error('Failed to save settings');
        alert('Failed to save settings');
      }
    } catch (error) {
      console.error('Error saving settings:', error);
      alert('Error saving settings');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (formData.supplyChain) {
      fetchUserSettings();
    }
  }, [formData.supplyChain]);

  const fetchUserSettings = async () => {
    try {
      const token = getAuthToken();
      if (!token) {
        console.error('No auth token found');
        return;
      }

      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}users/${formData.supplyChain}`, {
        headers: {
          'Authorization': token,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch user settings');
      }
      const data = await response.json();

      const preferences = data.customSettings?.preferences || {};
      const mappedData = {
        supplyChain: formData.supplyChain,
        imageCount: preferences.mandatoryImages || '',
        freeTextRemarks: preferences.addRemarks ? 'yes' : 'no',
        pointOfOrigin: preferences.pointOfOrgin ? 'yes' : 'no',
        editMaterial: preferences.twoFactor ? 'yes' : 'no',
        supplierRating: preferences.supplierRating ? 'yes' : 'no',
        batchManagement: preferences.batchManagement === 'AUTO' ? 'Automatic' : 'Manual',
        pricingInfo: preferences.pricingInfo ? 'yes' : 'no',
        paymentRecord: preferences.paymentRecord ? 'yes' : 'no'
      };
      setFormData(mappedData);
      setOriginalFormData(mappedData);
      setHasChanges(false);

    } catch (error) {
      console.error('Error fetching user settings:', error);
    }
  };

  const handleBatchManagementChange = (value) => {
    if (value === 'Manual') {
      setShowQRModal(true);
    } else {
      handleRadioChange('batchManagement', value);
    }
  };

  return (
    <KTCard>
      <style>{`
        input[type="checkbox"]:checked::after {
          content: '✓';
          position: absolute;
          color: white;
          font-size: 16px;
          font-weight: bold;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      `}</style>
      <div style={{
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
        maxWidth: '1000px',
      }}>
        <div style={{ padding: '20px' }}>
          {/* Supply chain Dropdown */}
          <div style={{ padding: '15px', marginBottom: '15px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
              <label style={{ color: 'black', fontWeight: 'normal', fontSize: '16px' }}>
                Select supply chain
              </label>
              <select
                value={formData.supplyChain}
                onChange={(e) => handleInputChange('supplyChain', e.target.value)}
                style={{
                  border: '1px solid black',
                  borderRadius: '6px',
                  padding: '8px 15px',
                  color: 'black',
                  backgroundColor: 'white',
                  fontSize: '14px',
                  fontWeight: 'normal'
                }}
              >
                <option value="">Drop Down</option>
                {supplyChainOptions.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option?.personalDetails?.name || option?.name || option?.firstName || option?.userName}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Image Count Input */}
          <div style={{ padding: '15px', marginBottom: '15px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <label style={{ color: 'black', fontWeight: 'normal', fontSize: '16px', flex: 1 }}>
                Enter the number of images which should be mandatorily collected for every transaction
              </label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <input
                  type="number"
                  value={formData.imageCount}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === '' || (parseInt(value) >= 0 && parseInt(value) <= 2)) {
                      handleInputChange('imageCount', value);
                    }
                  }}
                  onKeyPress={(e) => {
                    if (!/[0-2]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
                      e.preventDefault();
                    }
                  }}
                  style={{
                    border: '1px solid black',
                    borderRadius: '6px',
                    padding: '8px 12px',
                    color: 'black',
                    backgroundColor: 'white',
                    fontSize: '14px',
                    fontWeight: 'normal',
                    width: '80px'
                  }}
                  max="2"
                  min="0"
                />
              </div>
            </div>
          </div>

          {/* Free Text Remarks */}
          <div style={{ padding: '15px', marginBottom: '15px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <label style={{ color: 'black', fontWeight: 'normal', fontSize: '16px', flex: 1 }}>
                Do you want to free text remarks for material collection and dispatch
              </label>
              <label style={{ cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  name="freeTextRemarks"
                  checked={formData.freeTextRemarks === 'yes'}
                  onChange={(e) => handleRadioChange('freeTextRemarks', e.target.checked ? 'yes' : 'no')}
                  style={formData.freeTextRemarks === 'yes' ? checkboxCheckedStyle : checkboxStyle}
                />
              </label>
            </div>
          </div>

          {/* Point of Origin */}
          <div style={{ padding: '15px', marginBottom: '15px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <label style={{ color: 'black', fontWeight: 'normal', fontSize: '16px', flex: 1 }}>
                Do you need to capture the "Point of Origin" for the material collection
              </label>
              <label style={{ cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  name="pointOfOrigin"
                  checked={formData.pointOfOrigin === 'yes'}
                  onChange={(e) => handleRadioChange('pointOfOrigin', e.target.checked ? 'yes' : 'no')}
                  style={formData.pointOfOrigin === 'yes' ? checkboxCheckedStyle : checkboxStyle}
                />
              </label>
            </div>
          </div>

          {/* Edit Material */}
          <div style={{ padding: '15px', marginBottom: '15px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <label style={{ color: 'black', fontWeight: 'normal', fontSize: '16px', flex: 1 }}>
                Do you need an option to edit the material inwarding after recorded from mobile app
              </label>
              <label style={{ cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  name="editMaterial"
                  checked={formData.editMaterial === 'yes'}
                  onChange={(e) => handleRadioChange('editMaterial', e.target.checked ? 'yes' : 'no')}
                  style={formData.editMaterial === 'yes' ? checkboxCheckedStyle : checkboxStyle}
                />
              </label>
            </div>
          </div>

          {/* Supplier Rating */}
          <div style={{ padding: '15px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <label style={{ color: 'black', fontWeight: 'normal', fontSize: '16px', flex: 1 }}>
                Do you need the supplier rating function
              </label>
              <label style={{ cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  name="supplierRating"
                  checked={formData.supplierRating === 'yes'}
                  onChange={(e) => handleRadioChange('supplierRating', e.target.checked ? 'yes' : 'no')}
                  style={formData.supplierRating === 'yes' ? checkboxCheckedStyle : checkboxStyle}
                />
              </label>
            </div>
          </div>

          {/* Batch Management */}
          {/* Batch Management */}
          <div style={{ padding: '15px', marginBottom: '15px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <label style={{ color: 'black', fontWeight: 'normal', fontSize: '16px', flex: 1 }}>
                How do you want to do batch management in the supply chain
              </label>
              <div style={{ display: 'flex', gap: '20px' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }}>
                  <input
                    type="radio"
                    name="batchManagement"
                    value="Manual"
                    checked={formData.batchManagement === 'Manual'}
                    onChange={(e) => handleBatchManagementChange(e.target.value)}
                    style={{ accentColor: 'black' }}
                  />
                  <span style={{ color: 'black', fontWeight: 'normal', fontSize: '16px' }}>Manual</span>
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }}>
                  <input
                    type="radio"
                    name="batchManagement"
                    value="Automatic"
                    checked={formData.batchManagement === 'Automatic'}
                    onChange={(e) => handleRadioChange('batchManagement', e.target.value)}
                    style={{ accentColor: 'black' }}
                  />
                  <span style={{ color: 'black', fontWeight: 'normal', fontSize: '16px' }}>Automatic</span>
                </label>
              </div>
            </div>
          </div>

          {/* Pricing Information */}
          <div style={{ padding: '15px', marginBottom: '15px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <label style={{ color: 'black', fontWeight: 'normal', fontSize: '16px', flex: 1 }}>
                Do you want to record the pricing information while buying and selling
              </label>
              <label style={{ cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  name="pricingInfo"
                  checked={formData.pricingInfo === 'yes'}
                  onChange={(e) => handleRadioChange('pricingInfo', e.target.checked ? 'yes' : 'no')}
                  style={formData.pricingInfo === 'yes' ? checkboxCheckedStyle : checkboxStyle}
                />
              </label>
            </div>
          </div>

          {/* Payment Record */}
          <div style={{ padding: '15px', marginBottom: '15px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <label style={{ color: 'black', fontWeight: 'normal', fontSize: '16px', flex: 1 }}>
                Do you want to record mode of payment while buying the materials
              </label>
              <label style={{ cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  name="paymentRecord"
                  checked={formData.paymentRecord === 'yes'}
                  onChange={(e) => handleRadioChange('paymentRecord', e.target.checked ? 'yes' : 'no')}
                  style={formData.paymentRecord === 'yes' ? checkboxCheckedStyle : checkboxStyle}
                />
              </label>
            </div>
          </div>

          {/* Save Button */}
          <div style={{
            padding: '20px',
            textAlign: 'right',
            borderTop: '1px solid #eee',
            marginTop: '20px'
          }}>
            <button
              onClick={handleSave}
              disabled={loading || !hasChanges}
              style={{
                backgroundColor: (loading || !hasChanges) ? '#ccc' : '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                padding: '12px 30px',
                fontSize: '16px',
                fontWeight: 'normal',
                cursor: (loading || !hasChanges) ? 'not-allowed' : 'pointer'
              }}
            >
              {loading ? 'Saving...' : 'Save'}
            </button>
          </div>
        </div>

        {/* QR Code Modal */}
        {showQRModal && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.1)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
          }}>
            <div style={{
              backgroundColor: '#fff5f8',
              borderRadius: '12px',
              maxWidth: '650px',
              position: 'relative',
              border: 'none'
            }}>
              <button
                type="button"
                className="position-absolute"
                style={{
                  top: '15px',
                  right: '15px',
                  background: 'none',
                  border: 'none',
                  fontSize: '20px',
                  color: 'black',
                  cursor: 'pointer',
                  padding: '0',
                  width: '24px',
                  height: '24px',
                  zIndex: 1000,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                onClick={() => setShowQRModal(false)}
              >
                ×
              </button>

              <div className="text-center py-5" style={{ padding: '40px' }}>
                <div className="mb-4 d-flex justify-content-center">
                  <lottie-player
                    src="/success-animation.json"
                    background="transparent"
                    speed="1"
                    style={{ width: '80px', height: '80px' }}
                    loop={false}
                    autoplay
                  />
                </div>

                <h4 style={{ color: '#1f2937', fontWeight: '600', marginBottom: '20px' }}>
                  ⚠ Enable QR Code based material tracking Mode?
                </h4>

                <p style={{ color: '#6b7280', marginBottom: '30px', lineHeight: '1.5' }}>
                  Are you equipped with QR code printers to print batch tags for each bag, bale, or jumbo bag?
                </p>
                <p style={{ color: '#6b7280', marginBottom: '30px', lineHeight: '1.5' }}>
                  Enabling this mode will require QR code scanning on every SKU to record all activities accurately.
                </p>
                <p style={{ color: 'green', marginBottom: '30px', lineHeight: '1.5' }}>
                  ✅ Are you sure you want to proceed?
                </p>
                <p style={{ fontSize: '12px', color: '#666', marginBottom: '30px', lineHeight: '1.5' }}>
                  If you're unsure or need assistance, please contact the Helpdesk before enabling this mode.
                </p>

                <div className="d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn"
                    style={{
                      backgroundColor: 'transparent',
                      border: '1px solid #f1416c',
                      color: '#f1416c',
                      padding: '10px 24px',
                      borderRadius: '8px',
                      fontWeight: '500',
                      marginRight: "10px"
                    }}
                    onClick={() => setShowQRModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn"
                    style={{
                      backgroundColor: '#f1416c',
                      border: 'none',
                      color: 'white',
                      padding: '10px 24px',
                      borderRadius: '8px',
                      fontWeight: '500'
                    }}
                    onClick={() => {
                      handleRadioChange('batchManagement', 'Manual');
                      setShowQRModal(false);
                    }}
                  >
                    Yes, Proceed
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </KTCard>
  )
}

const AppSetting = () => (
  <QueryRequestProvider initialValue={{ initialApi: 'auditStandards' }}>
    <QueryResponseProvider>
      <ListViewProvider>
        <UsersList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { AppSetting }